import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListadoTipoDispositivosComponent } from './listado-tipo-dispositivos/listado-tipo-dispositivos.component';

const routes: Routes = [
  {
    path: '',
    component: ListadoTipoDispositivosComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TipoDispositivosRoutingModule {}
